import React, { useCallback, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ChatMessageComponent from 'react/chat/inner/display_pieces/messages/ChatMessageComponent';
import MatchResultCard from 'react/chat/inner/display_pieces/messages/kinds/MatchResultCard';
import ModeratorEventLine from 'react/chat/inner/display_pieces/messages/kinds/ModeratorEventLine';
import { ChatMessageNotification } from 'models/ChatMessage';

import * as chatActions from 'react/redux/actions/chat';
import ChatFirstLoadPlaceholder from 'react/chat/inner/display_pieces/loading/ChatFirstLoadPlaceholder';
import { __ } from 'i18n/index';

function ChatMessagesComponent(props) {
	const { chatMessages, scrollToBottom, scrollCheck } = props;
	const {
		isOnline, websocketIsReady, scrollPosition, isMobile, visibleMessages, activePopupChatMessage, submittingEditChatMessages, editingChatMessageType, editingChatMessageId, endChatMessageEditMode, submitMessageEdit,
		chatMessageDeleteHighlightPlayerId, chatMessageDeleteHighlightContext, completedInitialLoad, initialLoadFailed, showChatEmptyBanner
	} = props;

	const currentMessages = useRef([]);
	const scrollTop = useRef(null);

	useEffect(() => {
		if(!chatMessages.hasContext()) {
			return;
		}
		if(!isOnline) {
			return;
		}
		chatMessages
			.viewActivated()
			.then(() => {
				scrollToBottom();
			})
			.catch((error) => {
				console.error(error);
			});
	}, [isOnline, websocketIsReady, chatMessages]);

	useEffect(() => {
		if(!currentMessages.current.length) {

			return;
		}
		const last = currentMessages.current[currentMessages.current.length - 1];
		if(last.player && last.player.isMe() && !last.id && !last.usedToScrollToBottom) {
			last.usedToScrollToBottom = true;
			scrollToBottom();
		}
	});

	useEffect(() => {
		if(!scrollCheck) {
			return;
		}
		scrollCheck();
	});

	const messageArray = [];

	let previousMessage = null;
	let comboLength = 0;

	for(let [index, message] of visibleMessages) {
		if(message.isSelfDeletedLfgCard && message.isSelfDeletedLfgCard()) {
			continue;
		}
		if(message.type === ChatMessageNotification.types.CHAT_MESSAGE && (!previousMessage || !message.time.isSame(previousMessage.time, 'day'))) {
			const dateChange = ChatMessageNotification.create();
			dateChange.type = ChatMessageNotification.types.DATE_CHANGE;
			dateChange.date = message.time.clone();
			messageArray.push(dateChange);
			comboLength = 200;
			message.previousMessageHasSameOwner = false;
		}
		if(previousMessage && previousMessage.player === message.player && comboLength < 8 && !previousMessage.isNotification
			&& !isOneLineNotice(previousMessage) && !isOneLineNotice(message)) {
			comboLength++;
			message.previousMessageHasSameOwner = true;
		}
		else {
			comboLength = 0;
			message.previousMessageHasSameOwner = false;
		}
		previousMessage = message;
		message.cacheIndex = index;
		messageArray.push(message);
	}
	currentMessages.current = messageArray;
	const optionalProps = {};

	// optionalProps.scrollToIndex = this.currentMessages.length -1;
	if(scrollPosition) {
		console.log('rawr set to scrollPosition');
		delete optionalProps.scrollToIndex;

		// optionalProps.scrollTop = this.element.current.scrollTop + this.updateScrollPositionAfterRender;

		console.log('attempt to set scroll position to ', optionalProps.scrollTop);
	}

	const chatMessageComponents = Array.from(currentMessages.current).map((message) => {
		if(isPostedResult(message)) {
			return <MatchResultCard key={message.getListKey()} message={message} />;
		}
		if(isModeratorEvent(message)) {
			return <ModeratorEventLine key={message.getListKey()} message={message} />;
		}
		let displayMannersWarning = false;
		let displayScamWarning = false;
		const isMe = message.player && message.player.isMe();
		if(chatMessages.match && message.player && !isMe && message.id) {
			if(message.player.reported_match_behavior.hasToxicWarning()) {
				displayMannersWarning = true;
			}
		}
		let submittingUpdate = null;
		if(submittingEditChatMessages[message.id] && submittingEditChatMessages[message.id].idType === 'DB_ID') {
			submittingUpdate = submittingEditChatMessages[message.id];
		}
		else if(submittingEditChatMessages[message.send_id] && submittingEditChatMessages[message.send_id].idType === 'SEND_ID'
			&& isMe) {
			submittingUpdate = submittingEditChatMessages[message.send_id];
		}
		return (
			<ChatMessageComponent
				key={message.getListKey()}
				isMobile={isMobile}
				message={message}
				chatMessages={chatMessages}
				submitMessageEdit={submitMessageEdit}
				endChatMessageEditMode={endChatMessageEditMode}
				displayMannersWarning={displayMannersWarning}
				displayScamWarning={displayScamWarning}
				sendFailed={message.sendFailed}
				submittingUpdate={submittingUpdate}
				isEditing={editingChatMessageId === message.id && editingChatMessageType === 'DB_ID' ||
				(editingChatMessageId === message.send_id && editingChatMessageType === 'SEND_ID' && isMe)}
				isHoverHighlighted={chatMessages.highlightedPlayer === message.player}
				isFocused={chatMessages.focusedMessageId !== null && chatMessages.focusedMessageId === message.id}
				isDeleteHighlighted={(activePopupChatMessage && activePopupChatMessage.id === message.id) ||
				(chatMessageDeleteHighlightContext === chatMessages && message.player && chatMessageDeleteHighlightPlayerId === message.player.id)
				}
			/>
		);
	});
	if(chatMessageComponents.length) {
		return (
			<React.Fragment>
				{chatMessageComponents}
			</React.Fragment>
		);
	}
	else if(!completedInitialLoad) {
		return (
			<ChatFirstLoadPlaceholder
				isLoading={!initialLoadFailed}
				failed={!!initialLoadFailed}
				onRetry={() => chatMessages.retryInitialLoad()}
			/>
		);
	}
	else {
		return (
			<div className='chat_closed'>
				<div className='banner_flat'>
					{showChatEmptyBanner &&
					<span>{__('This Chat is Empty!')}</span>
					}
				</div>
			</div>
		);
	}


}

// Posted set results are system messages drawn as a one-line notice, with no
// sender row, reactions or message menu.
function isPostedResult(message) {
	return !!(message.isSystemMessage && message.isSystemMessage() && message.getMatchResult());
}

// A match chat's "asked for a moderator" / "joined" / "left" line.
function isModeratorEvent(message) {
	return !!(message.getModeratorEvent && message.getModeratorEvent());
}

function isOneLineNotice(message) {
	return isPostedResult(message) || isModeratorEvent(message);
}

function mapStateToProps(state) {
	return {
		...state.popups,
		...state.chat,
		...state.windowSize,
		...state.connection,
		...state.windowFocus,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		...chatActions,
	}, dispatch);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ChatMessagesComponent);